import composeInstallation from '../utils/composeInstallation'

const install = composeInstallation({
  name: 'im',
  scriptId: 'im-jssdk',
  install: () => {
    /* eslint-disable */
    (function (w, d, l) {
      if (w.im) return;
      w.im = function () { };
      var s = 'script', r = d.createElement(s);
      d.async = !0;
    
      r.src = l;
      var u = d.getElementsByTagName(s)[0];
    
      u.parentNode.insertBefore(r, u);
    
    })(window, document, `https://prod-us-chatintime.s3.us-west-2.amazonaws.com/www/im/jsy_im_start.js?code=78d5cf4cc9ded7540e8b131c2f72a963`);
    /* eslint-enable */
  }
})

export { install }